// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PriceLimitMeasure } from './PriceLimitMeasure';
export class StrikePriceSettings {
    constructor(strikeVersion, strikePrice, putEnabled, callEnabled) {
        this.LowLimitPut = 0;
        this.LowLimitCall = 0;
        this.HighLimitPut = 0;
        this.HighLimitCall = 0;
        this.minLotPut = -1;
        this.minLotCall = -1;
        this.maxLotPut = -1;
        this.maxLotCall = -1;
        this.maxLotInCashPut = -1;
        this.maxLotInCashCall = -1;
        this.PriceLimitMeasurePut = PriceLimitMeasure.DISABLE;
        this.PriceLimitMeasureCall = PriceLimitMeasure.DISABLE;
        this.DescriptionPut = null;
        this.DescriptionCall = null;
        this.ExtFieldsPut = null;
        this.ExtFieldsCall = null;
        this.TradeSessionStatusIdPut = null;
        this.TradeSessionStatusIdCall = null;
        this.ExchangeSessionNamePut = null;
        this.ExchangeSessionNameCall = null;
        this.ContractIdPut = null;
        this.InstrumentTradableIDPut = null;
        this.ContractIdCall = null;
        this.InstrumentTradableIDCall = null;
        this.ISINPut = '';
        this.ISINCall = '';
        this.StrikeVersion = null;
        this.PutEnabled = false;
        this.CallEnabled = false;
        this.PutTicker = null;
        this.CallTicker = null;
        this.TradingModePut = null;
        this.TradingModeCall = null;
        this.StrikeVersion = strikeVersion;
        this.StrikePrice = strikePrice;
        this.PutEnabled = putEnabled;
        this.CallEnabled = callEnabled;
    }
}
